<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page :back="queryFormModel.businessDistrictId || queryFormModel.storeId">
        <!-- 内容 -->
        <div
            class="body"
            slot="body"
        >
            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="adPageTypeName"
                    label="广告页面类型"
                    min-width="100"
                />
                <el-table-column
                    label="是否启用"
                    width="80"
                >
                    <template
                        slot-scope="scope"
                        v-if="scope.row.id"
                    >
                        <el-switch
                            v-model="scope.row.isAvailable"
                            @input="onIsAvailableInput($event,scope)"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push(routerName +`?pageType=2&adPageType=${scope.row.adPageType}` + queryStr)"
                            v-if="!scope.row.id"
                        >
                            新增
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push(routerName +`/${scope.row.id}?pageType=2&adPageType=${scope.row.adPageType}`+ queryStr)"
                            v-if="scope.row.id"
                        >
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'AdPageDecoration',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                businessDistrictId: '',
                storeId: '',
            },
            // 表格数据
            tableData: [],
            routerName: '/om/decoration/adPage/edit',
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Sp.ShopDecoration.data({ ...queryData, pageType: 2 }).then(json => {
                const res = json.data;
                this.tableData = res.data;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onIsAvailableInput(val, scope) {
            const { row } = scope;
            if (!row) return;
            this.$api.Sp.ShopDecoration.status({
                id: row.id,
                isAvailable: row.isAvailable,
            })
                .then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                })
                .catch(() => {
                    this.$message({
                        message: '操作失败请重试！',
                        type: 'error',
                    });
                    row.isAvailable = !row.isAvailable;
                });
        },
    },
    computed: {
        queryStr() {
            if (this.queryFormModel.businessDistrictId)
                return `&businessDistrictId=${this.queryFormModel.businessDistrictId}`;
            if (this.queryFormModel.storeId) return `&storeId=${this.queryFormModel.storeId}`;
            return '';
        },
    },
    created() {
        this.queryFormModel.businessDistrictId = this.$route.params.businessDistrictId || '';
        if (this.queryFormModel.businessDistrictId) {
            this.routerName = '/sp/businessDistrict/adPage/edit';
        }
        this.queryFormModel.storeId = this.$route.params.storeId || '';
        if (this.queryFormModel.storeId) {
            this.routerName = '/sp/store/home/edit';
        }
    },
};
</script>

<style lang="scss">
</style>
